import { ReactNode } from "react";

// Props interface for base Skeleton component
interface SkeletonProps {
  children?: ReactNode;
  className?: string;
  width?: string | number;
  height?: string | number;
  rounded?: "none" | "sm" | "md" | "lg" | "xl" | "full";
  animate?: boolean;
}

// Base Skeleton Component - A versatile loading placeholder
const Skeleton: React.FC<SkeletonProps> = ({
  children,
  className = "",
  width,
  height,
  rounded = "md",
  animate = true,
}) => {
  // Map rounded prop to Tailwind classes
  const roundedClasses = {
    none: "rounded-none",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    xl: "rounded-xl",
    full: "rounded-full",
  };

  // Build inline styles for width and height if provided
  const inlineStyles: React.CSSProperties = {};
  if (width) {
    inlineStyles.width = typeof width === "number" ? `${width}px` : width;
  }
  if (height) {
    inlineStyles.height = typeof height === "number" ? `${height}px` : height;
  }

  return (
    <div
      className={`
        ${animate ? "animate-pulse" : ""}
        bg-gray-200 dark:bg-gray-700
        ${roundedClasses[rounded]}
        ${className}
      `}
      style={inlineStyles}
    >
      {children}
    </div>
  );
};

export default Skeleton;
